import React, { useState, useMemo, useCallback, useEffect } from 'react';
import {
  Menu,
  MenuButton,
  MenuList,
  MenuPopover,
  Button,
  MenuTrigger,
  MenuItemRadio,
  makeStyles,
  MenuDivider,
  tokens,
  mergeClasses,
} from '@fluentui/react-components';
import {
  Dismiss20Regular,
} from '@fluentui/react-icons';

const useStyles = makeStyles({
  menuPopover: {
    minWidth: '180px',
  },
  unselectedMenuButton: {
    '&[aria-expanded="false"]': {
      fontWeight: 'unset',
    },
  },
  enabledClearButton: {
    float: 'right',
    color: tokens.colorNeutralForeground2BrandHover,
  },
  disabledClearButton: {
    float: 'right',
    color: tokens.colorNeutralForegroundDisabled,
  },
});

export const ImportSourceFilter = (props) => {
  const {
    className,
    options,
    defaultImportSource,
    onChange,
    forceClear,
    i18n,
    onDismiss,
    defaultOpen = false,
  } = props;

  const classes = useStyles();
  const name = 'importSource';
  const [checkedValues, setCheckedValues] = useState({
    [name]: [defaultImportSource],
  });
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const onCheckedValueChange = (e, data) => {
    const {
      checkedItems,
    } = data;
    setCheckedValues(s => ({
      ...s,
      [name]: checkedItems,
    }));
  };

  const selectedChoice = useMemo(
    () => options.find(r => r.key === checkedValues[name][0]),
    [checkedValues, options]
  );

  // the string shown on dropdown title
  const dropdownTitle = selectedChoice ? selectedChoice.title : null;

  // when the X button on dropdown title is clicked
  const onDropdownClear = useCallback(() => {
    if (onChange && defaultImportSource !== null) {
      onChange(null);
    }
  }, [defaultImportSource, onChange]);

  // when dropdown list is dismissed
  const onDropdownDismiss = useCallback(() => {
    const importSource = checkedValues[name][0];
    if (importSource && onChange && defaultImportSource !== importSource) {
      onChange(importSource);
    }
  }, [checkedValues, defaultImportSource, onChange]);

  const isSelected = checkedValues[name][0] != null;

  const onOpenChange = (e, data) => {
    setIsOpen(data.open);
  };

  const clear = useCallback(() => {
    setIsOpen(false);
    setCheckedValues(() => ({
      [name]: [],
    }));
    onDropdownClear();
    if (onDismiss) {
      onDismiss();
    }
  }, [onDropdownClear, onDismiss]);

  useEffect(() => {
    if (forceClear) {
      clear();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [forceClear]);

  useEffect(() => {
    if (!isOpen) {
      onDropdownDismiss();
    }
  }, [isOpen, onDropdownDismiss]);

  return (
    <div className={className}>
      <Menu open={isOpen} checkedValues={checkedValues} onCheckedValueChange={onCheckedValueChange} hasCheckmarks onOpenChange={onOpenChange}>
        <MenuTrigger disableButtonEnhancement>
          <MenuButton appearance="subtle" className={isSelected ? 'import-source-button' : mergeClasses(classes.unselectedMenuButton, 'import-source-button')}>
            {isSelected ? dropdownTitle : i18n.getString(_TL_('Import source'))}
          </MenuButton>
        </MenuTrigger>

        <MenuPopover className={mergeClasses(classes.menuPopover, 'import-source-menu')}>
          <MenuList>
            {
              options.map(option => (
                <MenuItemRadio key={option.key} name={name} value={option.key} className={option.icon ? classes.item : ''}>
                  {option.text}
                </MenuItemRadio>
                ))
            }
            <MenuDivider />
            <div>
              <Button
                className={isSelected ? classes.enabledClearButton : classes.disabledClearButton}
                disabled={!isSelected}
                appearance="transparent"
                icon={<Dismiss20Regular />}
                onClick={() => clear()}
              >
                {i18n.getString(_TL_('Clear'))}
              </Button>
            </div>
          </MenuList>
        </MenuPopover>
      </Menu>
    </div>
  );
};

